/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
// Composables
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa-svg'

const myCustomTheme = {
  dark: false,
  colors: {

    primary: '#3D5A80',
    secondary: '#98C1D9',
    accent: '#EE6C4D',
    info: '#03c9d7',
    success: '#00c853',
    warning: '#FB8B24',
    error: '#9A031E',
  }
};
const myDarkTheme = {
  dark: true,
  variables: {
    'overlay-background': '#1a1b25',
  },
  colors: {
    background: '#1f1f26',
    surface: '#131319',
    'surface-dim': '#131319',
    'surface-bright': '#393840',
    'on-surface': '#e4e1ea',
    outline: '#908f9d',
    'outline-variant': '#454652',
    primary: '#bcc2ff',
    'on-primary': '#152383',
    secondary: '#9ccbfc',
    'on-secondary': '#003354',
    tertiary: '#ddb8ff',
    'on-tertiary': '#461373',
    accent: '#ffa23e',
    info: '#03c9d7',
    success: '#00c853',
    warning: '#FB8B24',
    error: '#9A031E',
    'on-error': '#690005',
    'surface-light': '#393840',
  }
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  theme: {
    defaultTheme: 'myDarkTheme',
    themes: {
      myDarkTheme,
      myCustomTheme,
    }
  },
  components: {
    VIconBtn
  },
  defaults: {
    VBottomNavigation: {
      color: 'primary',
      horizontal: true,
      density: 'compact',
    },
    VBtn: {
      variant: 'text',
      color: 'secondary',
      class: 'ma-1',
      style: '--fa-secondary-color: #f7b801; --fa-secondary-opacity: 1'
    },
    VBtnGroup: {
      density: 'compact',
      variant: 'text',
      color: 'primary'
    },

    VCard: {
      rounded: 'lg',
      variant: 'tonal',
      hover: true,
    },

    VCardActions: {
      VBtn: {
        color: 'secondary',
        style: '--fa-secondary-color: #f7b801; --fa-secondary-opacity: 1'
      }
    },

    VCarousel: {
      hideDelimiters: true,
      progress: 'secondary',
    },

    VCarouselItem: {
      class: 'pa-0',
      cover: true
    },

    VChip: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      label: true,
      class: 'ma-1'
    },

    VChipGroup: {
      baseColor: 'primary',
      showArrows: false,
    },

    VDataTable: {
      density: 'compact',
      sortAscIcon: 'fasdr fa-arrow-down-short-wide',
      sortDescIcon: 'fasdr fa-arrow-down-wide-short',
      firstIcon: 'fasdr fa-chevrons-left',
      lastIcon: 'fasdr fa-chevrons-right',
      prevIcon: 'fasdr fa-angle-left',
      nextIcon: 'fasdr fa-angle-right',
      showCurrentPage: true,
      hover: true,
      itemsPerPage: 15,
      itemsPerPageOptions: [15, 25, 50, 100],
      striped: 'even',
      VBtn: {
        color: 'primary',
        variant: 'plain'

      }
    },
    VDialog: {
      VCard: {
        density: 'compact',
        variant: 'tonal',
        class: 'mx-auto'
        // height: '600px'
      }
    },
    VDivider: {
      inset: true
    },
    VFab: {
      absolute: true,
      activeColor: 'primary',
      color: 'secondary',
      border: 'lg',
    },
    VIcon: {
      // style: '--fasdr fa-secondary-opacity: 0.6;'
      style: '--fasdr; --fa-secondary-color: #F0E6EF; --fa-secondary-opacity: 0.6'
    },
    VIconBtn: {
      color: 'secondary',
      style: '--fa-secondary-color: #F0E6EF; --fa-secondary-opacity: 0.6'

    },
    VHotkey: {
      displayMode: 'symbol'
    },
    VListItem: {
      density: 'compact',
      baseColor: 'accent',
      color: 'primary',
      slim: true,
    },
    VListItemTitle: {
      class: 'text-start',
    },
    VListItemSubtitle: {
      class: 'text-start text-secondary',
    },
    VListSubheader: {
      class: 'bg-primary',
    },
    VMenu: {
      location: 'bottom',
      transition: 'slide-y-transition'
    },

    VNavigationDrawer: {
      left: true,
      temporary: true,
      width: '600',
    },
    VNumberInput: {
      variant: 'solo',
      controlVariant: 'split',
      flat: 'true',

    },
    VSelect: {
      menuIcon: 'fasdr fa-angle-down'
    },

    VSheet: {
      rounded: 'lg',
      border: 'md'
    },

    VSlideGroup: {
      showArrows: true,
      centerActive: true,
      prevIcon: 'fasdr fa-angle-left',
      nextIcon: 'fasdr fa-angle-right',
    },

    VSnackbar: {
      vertical: true,
      closable: true,
      prependIcon: 'fasdr fa-triangle-exclamation'
    },

    VTextField: {
      color: 'primary',
      density: 'compact',
      border: 'md',
      variant: 'outlined',
      rounded: 'lg',
      clearIcon: 'fasdr fa-circle-xmark',
      class: 'ma-2',

    },
    VToolbar: {
      rounded: 'lg',
      density: 'comfortable',
      border: 'md',
      VBtn: {
        tile: true,
        color: 'primary',
        size: 'small'
      }
    },

    VTooltip: {
      openOnHover: true,
      location: 'bottom',
      activator: 'parent'
    },
    VVirtualScroll: {
      height: '550px'
    }
  }
})
